<!-- Same badge style as app-license-status (shape, icon in a circle, colors, dark mode) so status badges look alike -->
@if (config) {
  <span class="w-max inline-flex items-center gap-1 py-0.5 px-3 rounded-4xl text-[13px] border {{ config.class }}">
    <i-tabler class="icon-14" [name]="config.icon" />
    {{ config.label | translate }}
  </span>
}
